/**
 * The shared block headings, authored once for all ten metals.
 *
 * The research sheets treat these as a fixed taxonomy: every metal gets the same slots in
 * the same order, each either filled or marked `n/a`. A metal fills a slot by including the
 * block and omits it by leaving it out — which slots a given metal skips is recorded in its
 * own translations file, not here. So the heading is never re-typed, and ten metals cannot
 * drift into "Climate change" vs "Climate Change".
 *
 * Ids carry no metal slug, like `metal_phone_part_*`: one string, translated once.
 */
export default {
  environmentalWater: {
    id: 'rm_metal_section_env_water',
    defaultMessage: 'Water scarcity and pollution',
  },
  environmentalSoil: {
    id: 'rm_metal_section_env_soil',
    defaultMessage: 'Soil erosion and contamination',
  },
  environmentalBiodiversity: {
    id: 'rm_metal_section_env_biodiversity',
    defaultMessage: 'Biodiversity loss',
  },
  environmentalClimate: {
    id: 'rm_metal_section_env_climate',
    defaultMessage: 'Climate change',
  },
  humanDisplacement: {
    id: 'rm_metal_section_human_displacement',
    defaultMessage: 'Displacement and land rights',
  },
  humanWaterRights: {
    id: 'rm_metal_section_human_water_rights',
    defaultMessage: 'Water rights',
  },
  humanHealth: {
    id: 'rm_metal_section_human_health',
    defaultMessage: 'Health and disease',
  },
  humanChildLabour: {
    id: 'rm_metal_section_human_child_labour',
    defaultMessage: 'Child labour and vulnerable groups',
  },
  humanGender: {
    id: 'rm_metal_section_human_gender',
    defaultMessage: 'Gender and gendered violence',
  },
  humanLegal: {
    id: 'rm_metal_section_human_legal',
    defaultMessage: 'Legal rights and protections',
  },
  geopoliticalDug: {
    id: 'rm_metal_section_geo_dug',
    defaultMessage: "Where it's dug",
  },
  geopoliticalProcessed: {
    id: 'rm_metal_section_geo_processed',
    defaultMessage: "Where it's processed",
  },
  geopoliticalLeverage: {
    id: 'rm_metal_section_geo_leverage',
    defaultMessage: "How it's used as leverage",
  },
  supplyRiskReserves: {
    id: 'rm_metal_section_supply_reserves',
    defaultMessage: 'How much is left?',
  },
  supplyRiskDemand: {
    id: 'rm_metal_section_supply_demand',
    defaultMessage: 'How much will we need?',
  },
  recyclingInput: {
    id: 'rm_metal_section_recycling_input',
    defaultMessage: 'How much recycled metal goes into new products?',
  },
  recyclingOutlook: {
    id: 'rm_metal_section_recycling_outlook',
    defaultMessage: 'Can recycling close the gap?',
  },
} as const
